const getOptionsForTimeSelect = (minutesPerSlot = 30) => {
    const options = [];
    const hoursPerDay = 24;
    const minutesPerHour = 60;
    const numberOfSlots = parseInt(minutesPerHour / minutesPerSlot);

    for (let i = 0; i < hoursPerDay; i += 1) {
        const hoursString24Hrs = (`0${i}`).slice(-2);
        const hoursString12Hrs = i < 13 ? (`${i === 0 ? 12 : i}`).slice(-2) : (`${i % 12}`).slice(-2);

        for (let j = 0; j < numberOfSlots; j += 1) {
            const minutesString = j === 0 ? '00' : j * minutesPerSlot;
            const meridiemString = i < 12 ? 'am' : 'pm';

            options.push({
                value: `${hoursString24Hrs}:${minutesString}`,
                title: `${hoursString12Hrs}:${minutesString} ${meridiemString}`,
            });
        }
    }

    return options;
};

export default getOptionsForTimeSelect;
